import { defineComponent as _defineComponent } from 'vue'
import { mdiClose } from "@mdi/js";
import { computed, ref, useAsync, useContext, useRouter } from "@nuxtjs/composition-api";

import { useAuth, useAxios, useTranslate } from "@/composables";
import { isNewUser } from "@/schemes/auth0";
import { useSignedPoliciesStore } from "@/store/signed-policies";
import { handleErrorStatusCode, handleServiceError } from "@/utils/api";
import { CREATED } from "@/utils/enums/http-codes";
import PrivacyService from "@/utils/services/PrivacyService";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkLegal',
  setup(__props, { expose }) {

const axios = useAxios();
const router = useRouter();
const { t } = useTranslate();
const ctx = useContext();
const auth = useAuth();
const signedPoliciesStore = useSignedPoliciesStore();

const showDeleteAccountModal = ref(false);
const showSnackbar = ref(false);
const message = ref("");

const fetch = async () => {
  // Skip checking for new users as they should have implicitly signed the policies on signup
  if (isNewUser(auth.user)) {
    return;
  }

  try {
    await signedPoliciesStore.fetchSignedPolicies();
  } catch (error) {
    return handleServiceError({
      context: ctx,
      error: {
        status: handleErrorStatusCode(error),
        errorCode: "ltk-privacy-info-not-found",
        developerMessage: "Error fetching legal policies",
      },
      originalError: error,
    });
  }
};

useAsync(async () => {
  await fetch();
  return true;
}, "legal fetch");

const showLegalModal = computed(() => {
  // Skip showing for new uses as they should have implicitly signed the policies on signup
  if (isNewUser(auth.user)) {
    return false;
  }

  const { signedPolicies } = signedPoliciesStore;
  return !signedPolicies?.cookie || !signedPolicies?.cookie || !signedPolicies?.privacy;
});

const closeIcon = () => {
  return mdiClose;
};

const agreeToNewTerms = async () => {
  try {
    await signedPoliciesStore.updateSignedPolicies({ cookie: true, privacy: true, tos: true });
  } catch (error) {}
};

const logout = () => {
  router.push("/logout");
};

const deleteUsersAccount = async () => {
  try {
    const privacyService = new PrivacyService(axios);
    const response = await privacyService.deleteAccount();
    if (response.status === CREATED) {
      logout();
    }
  } catch (error) {
    const translationParams = { message: "" };
    if (error !== null && typeof error === "object" && "message" in error) {
      translationParams.message = error.message as string;
    }

    // Error message displayed when deleting account
    message.value = t("Error deleting account: {message}", translationParams).value;
    showSnackbar.value = true;
  }
};

expose({
  showLegalModal,
  showSnackbar,
  agreeToNewTerms,
  deleteUsersAccount,
});

return { __sfc: true,axios, router, t, ctx, auth, signedPoliciesStore, showDeleteAccountModal, showSnackbar, message, fetch, showLegalModal, closeIcon, agreeToNewTerms, logout, deleteUsersAccount }
}

})